import { createSlice } from '@reduxjs/toolkit';

const normalizeId = (id) => {
  const parsed = Number(id);
  return Number.isFinite(parsed) ? parsed : id;
};

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    selectedMenuItem: "",
    isSidebarOpen: true,
    unreadPatientMessageIds: [],
    unreadStaffMessageIds :[],
    newStaffMessageCount: 0,
    taskListCount: 0,
    newReportCount: 0,
    appointmentsCount: 0,
    currentPath: ""
  },
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    addUnreadPatientMessageId: (state, action) => {
      const normalizedId = normalizeId(action.payload);
      if (!state.unreadPatientMessageIds.includes(normalizedId)) {
        state.unreadPatientMessageIds.push(normalizedId);
      }
    },
    removeUnreadPatientMessageId: (state, action) => {
      const normalizedId = normalizeId(action.payload);
      state.unreadPatientMessageIds = state.unreadPatientMessageIds.filter(id => id !== normalizedId);
    },
    addUnreadStaffMessageId: (state, action) => {
      const normalizedId = normalizeId(action.payload);
      if (!state.unreadStaffMessageIds.includes(normalizedId)) {
        state.unreadStaffMessageIds.push(normalizedId);
      }
    },
    removeUnreadStaffMessageId: (state, action) => {
      const normalizedId = normalizeId(action.payload);
      state.unreadStaffMessageIds = state.unreadStaffMessageIds.filter(id => id !== normalizedId);
    },
    setNewStaffMessageCount: (state,action) => {
      state.newStaffMessageCount = action.payload;
    },
    clearUnreadPatientMessageIds: (state) => {
      state.unreadPatientMessageIds = [];
    },
    clearUnreadStaffMessageIds: (state) => {
      state.unreadStaffMessageIds = [];
    },
    setSelectedMenuItem: (state, action) => {
      state.selectedMenuItem = action.payload;
    },

    setTaskListCount: (state, action) => {
      state.taskListCount = action.payload;
    },

    setCurrentPath: (state, action) => {
      state.currentPath = action.payload;
    },
    setSidebarItem: (state, action) => {
      const {key, value} = action.payload;
      state[key] = value;
    },
  },
});

export const { toggleSidebar , addUnreadPatientMessageId, removeUnreadPatientMessageId , 
  clearUnreadPatientMessageIds, clearUnreadStaffMessageIds, addUnreadStaffMessageId, removeUnreadStaffMessageId, 
  setNewStaffMessageCount, setSelectedMenuItem, setTaskListCount, setCurrentPath, setSidebarItem} = sidebarSlice.actions;
export default sidebarSlice.reducer;
